import { render, staticRenderFns } from "./RatioDiv.vue?vue&type=template&id=3169762f&scoped=true&"
import script from "./RatioDiv.vue?vue&type=script&setup=true&lang=ts&"
export * from "./RatioDiv.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./RatioDiv.vue?vue&type=style&index=0&id=3169762f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3169762f",
  null
  
)

export default component.exports